import React from 'react';
import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Typography,
  useTheme,
  Collapse,
  IconButton
} from '@mui/material';
import {
  Close as CloseIcon,
  NotificationsActive as NotificationIcon
} from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { useSubscriptionRenewal } from '../hooks/useSubscriptionRenewal';

interface SubscriptionRenewalAlertProps {
  onClose?: () => void;
}

const SubscriptionRenewalAlert: React.FC<SubscriptionRenewalAlertProps> = ({
  onClose
}) => {
  const theme = useTheme();
  const userData = useSelector((state: RootState) => state.user.data);
  const { showRenewalAlert, daysUntilRenewal, handleRenewal, setShowRenewalAlert } = useSubscriptionRenewal();

  // Se não houver data de fim do ciclo ou o usuário estiver no plano gratuito, não mostra o alerta
  if (!userData.currentCycleEnd || userData.plan === 'Free' || !showRenewalAlert) {
    return null;
  }

  const cycleEndDate = new Date(userData.currentCycleEnd);

  const handleClose = () => {
    setShowRenewalAlert(false);
    onClose?.();
  };

  return (
    <Collapse in={showRenewalAlert}>
      <Alert
        severity="info"
        icon={<NotificationIcon />}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={handleClose}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
        sx={{
          mb: 2,
          borderRadius: 2,
          '& .MuiAlert-icon': {
            color: theme.palette.primary.main
          }
        }}
      >
        <AlertTitle sx={{ color: theme.palette.primary.main }}>
          Renovação da Assinatura
        </AlertTitle>
        <Box sx={{ mt: 1 }}>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Sua assinatura do plano {userData.plan} será renovada em {daysUntilRenewal} {daysUntilRenewal === 1 ? 'dia' : 'dias'}.
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Data de renovação: {format(cycleEndDate, "dd 'de' MMMM 'de' yyyy", { locale: ptBR })}
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Valor da renovação: R$ {userData.planFeatures.price.toFixed(2)}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={handleRenewal}
            sx={{ mt: 1 }}
          >
            Renovar Agora
          </Button>
        </Box>
      </Alert>
    </Collapse>
  );
};

export default SubscriptionRenewalAlert; 